<template>
  <!-- Kompatibilitätsmodus für ältere Geräte, die keine Fotos im Hintergrund laden können -->
  <div v-if="!uuid"><a class="text-white" :href="apiUrl+'/register'" v-if="!uuid"><h1>Hier registrieren</h1></a></div>
  <ViewImagesStatisch v-else-if="kompatibel" />
  <ViewImages v-else />
</template>

<script>
import ViewImages from './components/ViewImages.vue'
import ViewImagesStatisch from './components/ViewImagesStatisch.vue'
export default {
  name: 'App',
  components: {
    ViewImages,
    ViewImagesStatisch
  },
  data() {
    return {
      uuid: null,
      apiUrl: null,
    }
  },
  computed: {
    kompatibel() {
      if (this.uuid && this.uuid.includes('kompatibel')) return true;
      return false;
    }
  },
  mounted() {
    this.uuid = window.location.pathname.slice(1);
    this.apiUrl = process.env.VUE_APP_API_URL;
  }
}
</script>

<style>
.text-white {
  color: #fff;
}
body {
    background-color: #000;
    height: 100%;
    width: 100%;
    margin: 0;
    padding: 0;
    text-align: center;
    overflow: hidden;
}
img {
  -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
    width: auto;        /* statt max-width */
    height: auto;       /* statt max-height */
    max-width: 100%;
    max-height: 100vh;
    position: relative;
    margin: auto;
}
</style>
